export const trainClasses = [
    { label: "First AC (1A)", value: "1A" },
    { label: "Second AC (2A)", value: "2A" },
    { label: "Third AC (3A)", value: "3A" },
    { label: "Sleeper (SL)", value: "SL" },
    { label: "AC Chair Car (CC)", value: "CC" },
    { label: "Executive Chair Car (EC)", value: "EC" },
    { label: "First Class (FC)", value: "FC" },
    { label: "Second Sitting (2S)", value: "2S" }
];

export const internationalPackage = [
    {
      "id": 1,
      "city": "Dubai",
      "country": "UAE",
      "image": "/images/destinations/dubai.jpg",
      "price": "₹25,999",
      "duration": "4N/5D",
      "tagline": "Desert Safari, Burj Khalifa, Shopping",
      "rating": 4.7
    },
    {
      "id": 2,
      "city": "Bali",
      "country": "Indonesia",
      "image": "/images/destinations/bali.jpg",
      "price": "₹29,499",
      "duration": "5N/6D",
      "tagline": "Beaches, Temples, Island Vibes",
      "rating": 4.8
    },
    {
      "id": 3,
      "city": "Paris",
      "country": "France",
      "image": "/images/destinations/paris.jpg",
      "price": "₹89,999",
      "duration": "5N/6D",
      "tagline": "Eiffel Tower, Cruise, City of Lights",
      "rating": 4.9
    },
    {
      "id": 4,
      "city": "Maldives",
      "country": "Maldives",
      "image": "/images/destinations/maldives.jpg",
      "price": "₹65,000",
      "duration": "3N/4D",
      "tagline": "Water Villas, Snorkeling, Luxury Stay",
      "rating": 4.6
    },
    {
      "id": 5,
      "city": "Singapore",
      "country": "Singapore",
      "image": "/images/destinations/singapore.jpg",
      "price": "₹34,999",
      "duration": "4N/5D",
      "tagline": "Universal Studios, Marina Bay, Night Safari",
      "rating": 4.5
    },
    {
      "id": 6,
      "city": "Switzerland",
      "country": "Switzerland",
      "image": "/images/destinations/switzerland.jpg",
      "price": "₹1,49,000",
      "duration": "6N/7D",
      "tagline": "Alps, Trains, Lakes",
      "rating": 5.0
    }
  ]
  